import { parseJson } from './application-utils';

/** Legacy `BankInfo` model, persisted as JSON in the `BankInfoJson` column of BYOD and MetLife. */
export interface BankInfo {
  ItemId?: string;
  Name: string;
  AccountNumber: string;
  BranchName: string;
  RoutingNumber: string;
}

/**
 * The stored bank info. Imported account numbers can carry a spreadsheet decimal ("12345.0"); like the
 * legacy `_stripAccountNumberDecimal`, only the part before the dot is the account number.
 */
export const readBankInfo = (bankInfoJson?: string): Partial<BankInfo> => {
  const info = parseJson<Partial<BankInfo>>(bankInfoJson, {});
  if (info.AccountNumber === null || info.AccountNumber === undefined) return info;
  return { ...info, AccountNumber: String(info.AccountNumber).split('.')[0] };
};
